import { Entity, IEntity } from "./Entity";
import { IApp03Workflow } from "./App03Workflow";
import { IApp03WorkflowStage } from "./App03WorkflowStage";
import { IApp03TaskUser } from "./App03TaskUser";
import { TaskPriority } from "../refData/WorkflowType";
import { getDate } from "date-fns/esm";
import { App03TaskAssignMethod } from "./AppGlobals";
import { IApp03TaskObserver } from "./App03TaskObserver";
import { IApp03TaskUserGroupsTemp } from "./App03TaskUserGroupsTemp";
import { IUser } from "./User";
import { IApp03Epic } from "./App03Epic";
import { IApp03Sprint } from "./App03Sprint";
import { IEntityCustomFields } from "./EntityCustomFields";
import { IApp03WorkItemType } from "./App03WorkItemType";


export interface IApp03Task extends IEntity, IEntityCustomFields {
    TaskRef?: string;
    ExternalRef?: string;
    WorkflowStageID?: number;
    WorkflowID?: number;
    Details?: string;
    TaskPriorityID?: number;
    Archived?: boolean;
    TargetStartDate?: Date | null;
    TargetEndDate?: Date | null;
    ActualStartDate?: Date | null;
    ActualEndDate?: Date | null;
    ProjectID?: number;
    UpdatePeriod?: Date | null;
    TaskManagerUserID?: number;
    AssignMethodID?: number;
    TaskTimeOption?: string;
    PlannedTime?: string;
    ActualTime?: string;
    SprintID?: number;
    EpicID?: number;
    TaskOrder?: number;
    PlanningStrategy?: string;
    CriticalDueDate?: Date;
    App03WorkItemTypeID?: number;
    App03WorkItemType?: IApp03WorkItemType;

    Epic?: IApp03Epic;
    Sprint?: IApp03Sprint;
    Workflow?: IApp03Workflow;
    TaskManagerUser?: IUser;
    WorkflowStage?: IApp03WorkflowStage
    App03TaskUsers?: IApp03TaskUser[];
    App03TaskObservers?: IApp03TaskObserver[];
    App03TaskUserGroupsTemps?: IApp03TaskUserGroupsTemp[];
}

export class App03Task extends Entity implements IApp03Task {
    public TaskRef = null;
    public ExternalRef = null;
    public WorkflowStageID = null;
    public WorkflowID = null;
    public Details = null;
    public TaskPriorityID = null;
    public Archived = null;
    public TargetStartDate = null;
    public TargetEndDate = null;
    public ActualStartDate = null;
    public ActualEndDate = null;
    public UpdatePeriod = null;
    public ProjectID = null;
    public TaskManagerUserID = null;
    public AssignMethodID = null;
    public TaskTimeOption = null;
    public PlannedTime = null;
    public ActualTime = null;
    public SprintID = null;
    public EpicID = null;
    public TaskOrder = null;
    public PlanningStrategy = null;
    public CriticalDueDate = null;
    public App03WorkItemTypeID = null;
    public CustomFields = [];

    constructor(workflowID: number, defaultStageID: number, defaultEpicID?: number, taskTimeOption?: string, planningStrategy?: string) {
        super();
        this.WorkflowID = workflowID;
        this.WorkflowStageID = defaultStageID;
        this.AssignMethodID = App03TaskAssignMethod.OneTaskForAll;
        this.TaskPriorityID = TaskPriority.Normal;
        this.TaskTimeOption = taskTimeOption;
        this.PlanningStrategy = planningStrategy;
        const now = new Date();
        this.TargetStartDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
        if (defaultEpicID > 0) {
            this.EpicID = defaultEpicID;
        }
    }

}

export const App03TaskTimeOptionKanban = {
    RequiredInDifficultyPoints: "RequiredInDifficultyPoints",
    RequiredInHours: "RequiredInHours",
    RequiredInDays: "RequiredInDays",
} as const;

export const App03TaskTimeOptionScrum = {
    UseStoryPoints: "UseStoryPoints",
    UseHours: "UseHours",
    UseDays: "UseDays",
} as const;

export const App03TaskTimeOptionLabels: Record<string, string> = {
    UseStoryPoints: "Story Points",
    UseHours: "Hours",
    RequiredInHours: "Hours",
    UseDays: "Days",
    RequiredInDays: "Days",
    RequiredInDifficultyPoints: "Difficulty Points",
    NotRequired: "Not Required",
};

export function getTaskTimeOptionLabel(option: string | null | undefined): string {
    if (!option) return "";
    return App03TaskTimeOptionLabels[option] ?? option;
}
